import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 1.5rem;
  width: 100%;
  margin: 1rem auto;
`;
